(function () {
  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) {
      return;
    }
    var id = String(variant.id);
    document.querySelectorAll('[data-legal-label-digital]').forEach(function (label) {
      var digital = label.dataset.legalLabelDigital.split(',');
      label.classList.toggle('hide', digital.indexOf(id) !== -1);
    });
  });
})();
